import * as React from "react";
import { Box, Text, Heading, Section } from "@vinomofo/components";
import kombi from "../../images/wine-clubs/kombi-white.svg";

const FinalSelector: React.FC = () => {
  return (
    <Section pt={[20, 10]} color={"white"}>
      <Box>
        <Heading as="h3" variant="sm" textAlign="center" color={"white"}>
          Let&apos;s get this show on the road.
        </Heading>
      </Box>
      <Box
        as="img"
        mt={["10px", "20px"]}
        mx="auto"
        width="40%"
        minWidth="250px"
        maxWidth="320px"
        display="block"
        opacity={1}
        src={kombi}
        alt=""
      />
      <Box mt={3}>
        <Text variant="sm" textAlign={"center"} color={"almostWhite"}>
          You&apos;ll need an account to join the club, whether you&apos;ve
          bought from us before or starting from scratch.
        </Text>
      </Box>
    </Section>
  );
};

export default FinalSelector;
